import { Link, useLocation } from 'react-router-dom';
import { ThemeToggle } from './ThemeToggle';
import { motion } from 'framer-motion';

export const Header = () => {
  const location = useLocation();
  const isModulePage = location.pathname.startsWith('/powr/');

  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="sticky top-0 z-50 bg-[hsl(var(--background))]/80 backdrop-blur-xl border-b border-[hsl(var(--border))]/40"
    >
      <div className="container mx-auto px-6 md:px-12 py-6 flex items-center justify-between">
        <Link to="/" data-testid="home-link">
          <h1 className="text-2xl md:text-3xl font-black tracking-tight">
            POWR
          </h1>
        </Link>

        <div className="flex items-center gap-4">
          {!isModulePage && (
            <Link
              to="/admin"
              data-testid="admin-link"
              className="text-sm font-mono uppercase tracking-[0.2em] hover:text-[hsl(var(--accent))] transition-colors"
            >
              Admin
            </Link>
          )}
          <ThemeToggle />
        </div>
      </div>
    </motion.header>
  );
};